import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import api from '../../api';
/* actions */
import { editVeterinarians } from '../../redux/actions/veterinarians';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/veterinarian';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';
import statesBR from '../../utils/statesBR';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    additionalInformation: '',
    crmvNumber: '',
    crmvUF: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const veterinarians = useSelector(state => state.veterinarians);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/veterinarians', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0],
            crmvNumber: data[0].crmv.number,
            crmvUF: data[0].crmv.uf
          };
          delete newData.crmv;
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  const submit = () => {
    const newData = {
      ...data,
      crmv: {
        number: data.crmvNumber,
        uf: data.crmvUF
      }
    };
    delete newData.crmvNumber;
    delete newData.crmvUF;
    dispatch(editVeterinarians(newData, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {veterinarians.editSuccess && (
        <AlertMsg type="success" msg="Veterinário atualizado com sucesso" />
      )}
      {veterinarians.errorContent &&
        !veterinarians.errorContent.message.includes('400') &&
        veterinarians.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização do veterinário"
        />
      )}
      {veterinarians.errorContent &&
        veterinarians.errorContent.message.includes('400') &&
        veterinarians.editError && (
        <AlertMsg
          type="danger"
          msg="Um veterinário com o CRMV informado já está cadastrada"
        />
      )}
      {!veterinarians.editSuccess && !veterinarians.editError && (
        <AlertMsg type="info" msg="Área atualização de veterinários" />
      )}
      <FormHeader title="Atualizar Veterinário" />
      <a
        className="btn btn-info"
        href="https://siscad.cfmv.gov.br/paginas/busca"
        target="_blank"
        rel="noopener noreferrer"
      >
        Consultar CRMV
      </a>
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="name">
                Nome<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                autoComplete="off"
                value={data.name}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.name && errors.name.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="crmvNumber">
                N&deg; CRMV<span className="field-required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="crmvNumber"
                name="crmvNumber"
                number="on"
                autoComplete="off"
                value={data.crmvNumber}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              />
              {errors.crmvNumber && errors.crmvNumber.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label htmlFor="crmvUF">
                UF CRMV<span className="field-required">*</span>
              </label>
              <select
                className="form-control"
                id="crmvUF"
                name="crmvUF"
                value={data.crmvUF}
                onChange={evt => handleChangeDefault(evt, data, setData)}
                ref={register}
              >
                <option value="">-- Selecione --</option>
                {Object.keys(statesBR).map((state, i) => {
                  return (
                    <option key={i} value={state}>
                      {statesBR[state]} - {state}
                    </option>
                  );
                })}
              </select>
              {errors.crmvUF && errors.crmvUF.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="additionalInformation">Informações Adicionais</label>
          <textarea
            className="form-control"
            id="additionalInformation"
            name="additionalInformation"
            rows="3"
            value={data.additionalInformation}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
        </div>
        <FormFooter url="/veterinarians" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
